export default __webpack_public_path__ + "static/media/phone-call.40885dc0.png";